import { defineStore, acceptHMRUpdate } from 'pinia';
import utilitiesData from '../../utilities/common/data';
import userClientRepository from '../../repositories/setting/userClientRepository';

const dataUserClient = {
  name: null,
  phone: null,
  email: null,
  username: null,
};

export const useUserClientStore = defineStore('userClientStore', {
  state: () => ({
    componentKey: 0,
    isSuccess: false,
    hasErrorSingle: null,
    // list page
    perpage: 20,
    search: null,
    page: 1,
    listData: [],
    pagination: {},
    isLoadingTable: false,
    // form page
    formData: structuredClone(dataUserClient),
    hasFormError: structuredClone(dataUserClient),
    isLoadingForm: false,
  }),
  actions: {
    async getData() {
      try {
        this.isLoadingTable = true;
        this.hasErrorSingle = null;
        this.isSuccess = false;

        const params = {
          search: this.search,
          page: this.page,
          perpage: this.perpage,
        };
        const dataUserClient = await userClientRepository.getData(params);
        if (dataUserClient.data.status === 200) {
          this.listData = dataUserClient.data.data.user_client.list;
          this.pagination = dataUserClient.data.data.user_client.pagination;
          this.isLoadingTable = false;
          this.componentKey++;
          this.isSuccess = true;
        }
      } catch (error) {
        console.log(error);
        this.isLoadingTable = false;
        this.isSuccess = false;
      }
    },
    async searchData() {
      this.page = 1;
      await this.getData();
    },
    async getDataByPaging() {
      await this.getData();
    },
    async saveData() {
      try {
        this.isLoadingForm = true;
        this.isSuccess = false;
        this.resetForm(false, false);

        const params = this.formData;
        const saveUserClient = await userClientRepository.saveData(params);
        if (saveUserClient.data.status === 200) {
          this.isSuccess = true;
          this.resetForm();
        }
      } catch (error) {
        console.log(error);
        this.setFormError(error.response.data.error);
        this.isSuccess = false;
        this.isLoadingForm = false;
      }
    },
    async getDataDetail(id) {
      this.isSuccess = false;

      const params = {
        user_id: id,
      };
      const dataDetailUserClient = await userClientRepository.getDataDetail(params);

      if (dataDetailUserClient.data.status === 200) {
        this.isSuccess = true;
        const data = dataDetailUserClient.data.data;
        this.formData = {
          name: data.name,
          phone: data.phone,
          email: data.email,
          username: data.username,
        };
      }
    },
    async updateData(id) {
      try {
        this.isSuccess = false;
        this.isLoadingForm = true;
        this.resetForm(false, false);

        const params = {
          user_id: id,
          ...this.formData,
        };
        const updateUserClient = await userClientRepository.updateData(params);
        if (updateUserClient.data.status === 200) {
          this.isSuccess = true;
          this.resetForm();
        }
      } catch (error) {
        console.log(error);
        this.setFormError(error.response.data.error);
        this.isSuccess = false;
        this.isLoadingForm = false;
      }
    },
    async deleteData(id) {
      try {
        this.isSuccess = false;

        const params = {
          user_id: id,
        };
        const deleteUserClient = await userClientRepository.deleteData(params);
        if (deleteUserClient.data.status === 200) {
          this.isSuccess = true;
        }
      } catch (error) {
        console.log(error);
        this.isSuccess = false;
      }
    },
    setFormError(error) {
      if (typeof error === 'string' || error instanceof String) {
        this.hasErrorSingle = error;
      } else {
        Object.keys(error).forEach((item) => {
          this.hasFormError[item] = error[item][0];
        });
      }
    },
    resetForm(withContent = true, withLoading = true) {
      if (withContent) {
        this.formData = structuredClone(dataUserClient);
      }
      this.hasFormError = structuredClone(dataUserClient);
      this.hasErrorSingle = null;
      if (withLoading) {
        this.isLoadingForm = false;
      }
    },
    removeErrorFormSingle(key) {
      this.hasFormError[key] = null;
    },
  },
  getters: {},
});

if (import.meta.webpackHot) {
  import.meta.webpackHot.accept(acceptHMRUpdate(useUserClientStore, import.meta.webpackHot));
}
